import React from 'react'
import { defineMessages } from 'react-intl'
import { GetApp } from 'components/GetApp/index.js'
import { CheckExerciseFormCTA } from 'pages/CheckExerciseForm/Cta/index.js'

const messages = defineMessages({
  description: {
    id: 'CheckExerciseFormGetApp.description',
    defaultMessage: 'Perfect Your Form with AI'
  }
})

export function CheckExerciseFormGetApp () {
  return (
    <GetApp
      descriptionMessage={messages.description}
      ctaComponent={
        <CheckExerciseFormCTA
          isCentered
        />
      }
    />
  )
}
